/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Namespaces / WebPaths that are not allowed to be used.
 * @export
 */
export const RESTRICTED_NAMESPACES = ['squiz'];
